'use strict';

var ConfigFunction = function ($httpProvider, $templateRequestProvider, bootstrapParametersProvider) {
    bootstrapParametersProvider.setParameters(params);
    $httpProvider.interceptors.push(templateInterceptor);
    $templateRequestProvider.httpOptions({ _isTemplate: true });

    function templateInterceptor() {
        return {
            request: function (config) {
                if (config._isTemplate) {
                    if (!(config.url.indexOf("http://") === 0 || config.url.indexOf("https://") === 0))
                        config.url = contentPath + config.url;
                }
                return config;
            }
        };
    }
}

ConfigFunction.$inject = ['$httpProvider', '$templateRequestProvider', 'bootstrapParametersProvider'];

module.exports = ConfigFunction;
